<template>
	<div class="container-tree">
		<div class="tree-table-grid theader" style="background-color: #02979b;">
			<span class="column-title" style="color: white;">Nombre</span>
			<span class="column-title" style="color: white;">Código</span>
			<span class="column-title" style="color: white;">Cuenta</span>
			<span class="column-title" style="color: white;">Acciones</span>
		</div>
		<TreeNodesDl class="tree-node" children="children" text="name" :indent="20" :nodes="treeData">
			<template slot-scope="{ node, isOpen }">
				<div class="tree-table-grid tbody" style="color: gray;">
					<div class="tree-title">
						<app-tooltip-button
							v-if="node.children.length > 0"
							:icon="isOpen ? 'remove_circle_outline' : 'add_circle_outline'"
							text="Agregar"
							:size="16"
							color="success"
						/>
						<span :class="{'childrens': node.children.length === 0}">{{ node.name }}</span>
					</div>
					<span class="tool-code" :class="{'childrens': node.children.length === 0}">
						{{ node.code }}
					</span>
					<span class="tool-type" :class="{'childrens': node.children.length === 0}">
						{{ node.account }}
					</span>
					<div class="tool-action">
						<app-tooltip-button
							color="success"
							icon="add_circle_outline"
							text="Agregar"
							:size="16"
							@click-icon="addItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							color="success"
							icon="edit"
							text="Editar"
							:size="16"
							@click-icon="editItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							img="/static/img/actions-list/delete.svg"
							text="Eliminar"
							:width="16"
							@click-icon="deleteItem($event, node, isOpen)"
						/>
					</div>
				</div>
			</template>
		</TreeNodesDl>
	</div>
</template>

<script>
import TreeNodesDl from 'tree-nodes-dl';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function addItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$emit('click-icon', 'add', node);
}

function editItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$emit('click-icon', 'edit', node);
}

function deleteItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$emit('click-icon', 'delete', node);
}

export default {
	name: 'tree-table',
	components: {
		TreeNodesDl,
		appTooltipButton,
	},
	methods: {
		addItem,
		editItem,
		deleteItem,
	},
	props: {
		treeData: {
			type: Array,
			default: [],
		},
	},
};
</script>

<style lang="scss" scoped>

.container-tree {
	padding: 10px 50px;
}
.theader {
	padding: 5px 0;
}

.tree-table-grid {
	align-items: center;
	display: grid;
	grid-template-columns: 1fr 120px 150px 150px;

	.column-title {
		font-family: font(lato-bold);
		font-size: size(small);
		text-align: center;
	}

	.tree-title {
		align-items: center;
		display: flex;
	}
}

.tree-node { 
	.tbody {
		padding-left: 35px;
		font-size: size(small10);
	}
	.tool-code {
		border-left: 1px solid   #02979b;
		padding: 5px;
		text-align: start;
	}

	.tool-type {
		border-left: 1px solid   #02979b;
		border-right: 1px solid   #02979b;
		padding: 10px 5px;
		text-align: start;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: center;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: space-evenly;
	}
}
.childrens {
	color: color(secondary) !important;
	font-weight: bold;
}

</style>


// WEBPACK FOOTER //
// src/components/shared/tree-table.vue